import { høyrejustert } from "./felt";

export class Kolonne<TFeltType> {
    navn: string;
    høyrejustert: boolean;
    constructor(
        public feltType: TFeltType,
        public definisjon: Gf.Web.Models.FeltDefinisjon<TFeltType>,
        public width: string,
        navn?: string,
        høyre?: boolean) {

        this.navn = navn || definisjon.Beskrivelse;
        this.høyrejustert = høyre !== undefined ? høyre : høyrejustert(definisjon);
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/Kolonne.ts